// The `PopularCategoryTastic` component dynamically selects carousel content based on
// the heading "POPULAR CATEGORIES" from the provided Tastic data. It passes this content
// to the `PopularCategorySection` component for rendering. This approach ensures a focused
// and reusable solution for showcasing popular categories in the UI. Its modular design
// simplifies content management and customization.

'use client';

import PopularCategorySection from 'components/commercetools-ui/organisms/content/popular-category';
import { TasticProps } from 'frontastic/tastics/types';
import React from 'react';
import { Carousel, CarouselTasticData } from 'types/next';
import useLocale from 'helpers/hooks/useLocale';

const PopularCategoryTastic = ({ data }: TasticProps<CarouselTasticData>) => {
  const { getCurrency } = useLocale();
  const selectedLocale = getCurrency() === 'GBP' ? 'en-GB' : 'en-EU';

  const discoverContent = data?.data?.dataSource?.carousels?.find(
    (content: Carousel) => content?.contentID === data?.contentID,
  ) as Carousel;

  // Only render if isShow for the current locale is true
  if (!discoverContent?.isShow?.[selectedLocale]) {
    return null;
  }

  return (
    <>
      <PopularCategorySection content={discoverContent} />
    </>
  );
};

export default PopularCategoryTastic;
